import { Accordion, AccordionSummary, AccordionDetails, Typography, Grid } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Trans, t } from '@lingui/macro'
import DateRangePickerInput from '@/components/ui/inputs/DateRangePickerInput'
import { EntityEvolutionComponent } from './charts/EntityEvolutionComponent'

type EntityEvolutionSectionProps = {
  isExpanded: boolean
  onChange: (event: React.SyntheticEvent, isExpanded: boolean) => void
  selectedRange: [Date, Date]
  onRangeChange: (range: { start: Date | null; end: Date | null }) => void
  entityEvolutionData: any
  isLoadingEntityEvolution: boolean
  isMobile: boolean
}

export function EntityEvolutionSection({
  isExpanded,
  onChange,
  selectedRange,
  onRangeChange,
  entityEvolutionData,
  isLoadingEntityEvolution,
  isMobile,
}: EntityEvolutionSectionProps) {
  return (
    <Accordion
      expanded={isExpanded}
      onChange={onChange}
      TransitionProps={{ unmountOnExit: false }}
      sx={{
        '& .MuiAccordionSummary-content': {
          margin: isMobile ? '10px 0' : undefined,
        },
      }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="entityEvolution-content" id="entityEvolution-header">
        <Typography variant="h6" sx={{ fontSize: isMobile ? '1rem' : undefined }}>
          <Trans>Entity Evolution</Trans>
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ p: isMobile ? 1 : 2 }}>
        <Grid container spacing={isMobile ? 2 : 3}>
          <Grid item xs={12}>
            <DateRangePickerInput
              value={selectedRange}
              onChange={onRangeChange}
              label={t`Select Date Range`}
              sx={{
                width: '100%',
                '& .MuiInputBase-input': {
                  fontSize: isMobile ? '0.875rem' : undefined,
                },
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <EntityEvolutionComponent data={entityEvolutionData} isLoading={isLoadingEntityEvolution} />
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  )
}
